import { render, staticRenderFns } from "./lightbox-photo-guidelines.vue?vue&type=template&id=92ce7cfe&"
import script from "./lightbox-photo-guidelines.vue?vue&type=script&lang=js&"
export * from "./lightbox-photo-guidelines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92ce7cfe')) {
      api.createRecord('92ce7cfe', component.options)
    } else {
      api.reload('92ce7cfe', component.options)
    }
    module.hot.accept("./lightbox-photo-guidelines.vue?vue&type=template&id=92ce7cfe&", function () {
      api.rerender('92ce7cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/lightbox-photo-guidelines.vue"
export default component.exports